import { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";

/**
 * Returns { hasAccess, loading } for the ID Card Generator.
 * - Superadmin: always has access
 * - Admin: access only if userData.idCardAccess === true in Firestore
 * - Employee: never has access
 */
const useIdCardAccess = () => {
  const { userData, loading: authLoading } = useAuth();
  const [hasAccess, setHasAccess] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (authLoading) return;
    if (!userData) {
      setHasAccess(false);
      setLoading(false);
      return;
    }
    if (userData.role === "superadmin") {
      setHasAccess(true);
    } else if (userData.role === "admin" && userData.idCardAccess === true) {
      setHasAccess(true);
    } else {
      setHasAccess(false);
    }
    setLoading(false);
  }, [userData, authLoading]);

  return { hasAccess, loading };
};

export default useIdCardAccess;
